import { ActionTree, GetterTree, MutationTree } from "vuex";
import { AcquisitionStore } from "@/types/AcquisitionTypes";

const state: AcquisitionStore = {
  payloadCheckout: [],
  paymentMethod: "CREDIT_CARD",
};

const getters: GetterTree<AcquisitionStore, any> = {
  payloadCheckout: (st) => st.payloadCheckout,
  paymentMethod: (st) => st.paymentMethod,
};

const mutations: MutationTree<AcquisitionStore> = {
  setPayloadCheckout(st: AcquisitionStore, { payloadCheckout }) {
    st.payloadCheckout = payloadCheckout;
  },
  setPaymentMethod(st: AcquisitionStore, { paymentMethod }) {
    st.paymentMethod = paymentMethod;
  },
};

const actions: ActionTree<AcquisitionStore, any> = {
  async setPaymentMethod({ commit }, paymentMethod) {
    commit("setPaymentMethod", { paymentMethod });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
